import { 
  TrendingUp, 
  TrendingDown, 
  Minus,
  ArrowUpRight,
  ArrowDownRight
} from 'lucide-react'
import Card from './Card'

const StatsCard = ({ 
  title, 
  value, 
  change, 
  changeType = 'neutral', 
  icon: Icon,
  iconColor = 'primary',
  description,
  className = ''
}) => {
  const getChangeIcon = () => {
    switch (changeType) {
      case 'positive':
        return <TrendingUp className="w-4 h-4 text-success-500" />
      case 'negative':
        return <TrendingDown className="w-4 h-4 text-error-500" />
      default:
        return <Minus className="w-4 h-4 text-secondary-400" />
    }
  }

  const getChangeColor = () => {
    switch (changeType) {
      case 'positive':
        return 'text-success-500'
      case 'negative':
        return 'text-error-500'
      default:
        return 'text-secondary-400'
    }
  }

  const getIconColor = () => {
    switch (iconColor) {
      case 'primary':
        return 'text-primary-400'
      case 'accent':
        return 'text-accent-400'
      case 'success':
        return 'text-success-500'
      case 'warning':
        return 'text-warning-500'
      case 'error':
        return 'text-error-500'
      default:
        return 'text-secondary-400'
    }
  }

  const formatValue = (val) => {
    if (typeof val === 'number') {
      if (val >= 1000000) {
        return `${(val / 1000000).toFixed(1)}M`
      } else if (val >= 1000) {
        return `${(val / 1000).toFixed(1)}K`
      }
      return val.toLocaleString()
    }
    return val
  }

  return (
    <Card className={`p-6 ${className}`} hover>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center space-x-2 mb-2">
            {Icon && (
              <div className={`p-2 rounded-lg bg-secondary-700/50`}>
                <Icon className={`w-5 h-5 ${getIconColor()}`} />
              </div>
            )}
            <h3 className="text-sm font-medium text-secondary-400">{title}</h3>
          </div>
          
          <div className="mb-2">
            <span className="text-2xl font-bold text-white">
              {formatValue(value)}
            </span>
          </div>
          
          {change !== undefined && (
            <div className={`flex items-center space-x-1 ${getChangeColor()}`}>
              {getChangeIcon()}
              <span className="text-sm font-medium">
                {change > 0 ? '+' : ''}{change}%
              </span>
            </div>
          )}
          
          {description && (
            <p className="text-xs text-secondary-500 mt-2">
              {description}
            </p>
          )}
        </div>
        
        {changeType !== 'neutral' && (
          <div className="flex-shrink-0">
            {changeType === 'positive' ? (
              <ArrowUpRight className="w-5 h-5 text-success-500" />
            ) : (
              <ArrowDownRight className="w-5 h-5 text-error-500" />
            )}
          </div>
        )}
      </div>
    </Card>
  )
}

export default StatsCard
